import { isHappa } from '@/constants'

import { useAuthRoles } from './use-auth-roles'
import { USER_PLAN_PREFIX, UserPlan } from '@/api/users/types'

export const USER_PLANS: UserPlan[] = ['pro', 'safe', 'suits']

/**
 * Extracts the user plan from the capabilities array.
 * The plan is stored as "plans:pro", "plans:safe", "plans:suits" inside capabilities.
 */
export const extractPlanFromCapabilities = (capabilities?: string[] | null): UserPlan | null => {
  if (!capabilities) return null
  const planCap = capabilities.find((cap) => cap.startsWith(USER_PLAN_PREFIX))
  if (!planCap) return null
  const value = planCap.slice(USER_PLAN_PREFIX.length) as UserPlan
  return USER_PLANS.includes(value) ? value : null
}

export const useUserPlan = () => {
  const { user } = useAuthRoles()

  const plan: UserPlan | null = isHappa ? extractPlanFromCapabilities(user?.capabilities) : null

  return {
    plan,
    isPro: plan === 'pro',
    isSafe: plan === 'safe',
    isSuits: plan === 'suits'
  }
}

/**
 * Helper to build capabilities array with plan included.
 * Use when admin assigns a plan: replaces any existing plan capability.
 */
export const setPlanInCapabilities = (
  capabilities: string[] | null | undefined,
  newPlan: UserPlan | null
): string[] => {
  const filtered = (capabilities || []).filter((cap) => !cap.startsWith(USER_PLAN_PREFIX))
  if (newPlan) {
    filtered.push(`${USER_PLAN_PREFIX}${newPlan}`)
  }
  return filtered
}
